import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FieldSelect, FieldText, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import noop from 'lodash/noop';
import { useCallback } from 'react';
import { connect } from 'react-redux';
import { Field, Form, reduxForm, } from 'redux-form';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getVariableNameErrorMessage, isValidVariableName, } from 'components/powerFlowShared/helpers/flowVariableHelpers';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { FieldAnnouncementPicker } from 'components/shared/announcementPicker';
import { AdapterTypes } from 'components/shared/announcementPicker/adapters';
import { getRequestID } from 'components/shared/util/request';
import styles from './dialInput.module.scss';
const ANNOUNCEMENT_FIELD = 'announcement';
const MAX_DIGITS_FIELD = 'max_digits';
const END_KEY_FIELD = 'end_key';
const VARIABLE_ID_FIELD = 'variable_id';
const validate = ({ announcement, end_key, variable_id, max_digits }, { initialValues, scopeVars }) => {
    const errors = {};
    if (!announcement) {
        errors[ANNOUNCEMENT_FIELD] = 'Please choose an announcement';
    }
    if (!max_digits && !end_key) {
        errors[MAX_DIGITS_FIELD] =
            'Please fill either max input length or pick an end key';
        errors[END_KEY_FIELD] =
            'Please fill either max input length or pick an end key';
    }
    if (!variable_id) {
        errors[VARIABLE_ID_FIELD] = 'Please fill variable name';
    }
    else if (variable_id !== initialValues.variable_id &&
        scopeVars.existing.indexOf(variable_id) !== -1) {
        errors[VARIABLE_ID_FIELD] = 'Variable name is already in use';
    }
    else if (!isValidVariableName(variable_id)) {
        errors[VARIABLE_ID_FIELD] = getVariableNameErrorMessage(variable_id) || '';
    }
    return errors;
};
function DialInputImpl({ handleSubmit, node, nodeLabel, replaceNode, triggerClose, variableIDLocked, dirty: isChanged, }) {
    const END_KEYS = [
        { id: '', name: 'None' },
        { id: '#', name: '#' },
        { id: '*', name: '*' },
    ];
    const handleSaveClick = useCallback(({ announcement, max_digits, end_key, variable_id }) => {
        var _a;
        const newNode = Object.assign(Object.assign({}, node), { icon: 'i-phone', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.DIAL_INPUT, overlay: [], payload: {
                next_node_id: ((_a = node.payload) === null || _a === void 0 ? void 0 : _a.next_node_id) || getRequestID(),
                announcement: {
                    file: Object.assign(Object.assign({}, announcement), { filename: announcement.label }),
                },
                max_digits,
                end_key,
                variable_id,
            }, text: 'Phone input' });
        replaceNode(newNode);
        triggerClose();
    }, [node, replaceNode, triggerClose]);
    return (_jsxs(Box, Object.assign({ width: "600px" }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: triggerClose }, { children: _jsx(Text.Paragraph, Object.assign({ subdued: true }, { children: "Allow customers to give input with their dial pad during a call (e.g. a PIN, ZIP code, or phone number)." })) })), _jsxs(Form, Object.assign({ onSubmit: handleSubmit(handleSaveClick) }, { children: [_jsxs(ModalBody, { children: [_jsx(Field, { adapter: AdapterTypes.Announcement, className: styles.field, component: FieldAnnouncementPicker, name: ANNOUNCEMENT_FIELD, onSelect: noop }), _jsx(Text.Heading, Object.assign({ className: styles.textHeading, variant: "heading-3" }, { children: "Input condition" })), _jsx(Text.Paragraph, Object.assign({ className: styles.paragraph }, { children: "Set a max number of key presses or an end key. You can also set both conditions" })), _jsx(Field, { className: styles.field, component: FieldText, label: "Max input length", min: "0", name: MAX_DIGITS_FIELD, parse: (val) => parseInt(val), placeholder: "-", type: "number" }), _jsx(Field, { className: styles.field, component: FieldSelect, items: END_KEYS, label: "End key", name: END_KEY_FIELD, selectedItems: [END_KEYS[0]] }), _jsx(Field, { component: FieldText, disabled: variableIDLocked, label: "Input variable name", name: VARIABLE_ID_FIELD, placeholder: "Type variable name" })] }), _jsx(ModalFoot, { cancelOnClick: triggerClose, confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, confirmOnClick: handleSubmit(handleSaveClick) })] }))] })));
}
const mapStateToProps = (_state, { node: { payload }, scopeVars }) => {
    var _a, _b, _c;
    const { announcement } = payload || {};
    const initialValues = Object.assign(Object.assign({}, payload), { announcement: announcement && {
            author: (_a = announcement.file.author) !== null && _a !== void 0 ? _a : '',
            url: (_b = announcement.file.url) !== null && _b !== void 0 ? _b : '',
            label: (_c = announcement.file.filename) !== null && _c !== void 0 ? _c : '',
        } });
    return {
        initialValues,
        variableIDLocked: (payload === null || payload === void 0 ? void 0 : payload.variable_id)
            ? scopeVars.descendantNeeds.indexOf(payload.variable_id) !== -1
            : false,
    };
};
export const DialInput = connect(mapStateToProps)(reduxForm({
    enableReinitialize: true,
    form: 'callFlowDialInputForm',
    validate,
})(DialInputImpl));
